var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPolicyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10256",
    "data-name": "Group 10256",
    transform: "translate(-1049 -434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1048.875 433.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17183",
    "data-name": "Rectangle 17183",
    width: 17,
    height: 17,
    transform: "translate(0 0)",
    fill: "#95abd3",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8937",
    "data-name": "Path 8937",
    d: "M10.82,8.639A2.82,2.82,0,1,0,8,5.82a2.82,2.82,0,0,0,2.82,2.82Z",
    transform: "translate(-2.477 -1.001)",
    fill: "#95abd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8938",
    "data-name": "Path 8938",
    d: "M14.164,18.639a.7.7,0,0,0,.7-.7,4.935,4.935,0,1,0-9.869,0,.7.7,0,0,0,.7.7Z",
    transform: "translate(-1.592 -3.952)",
    fill: "#95abd3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPolicyIcon);
export default __webpack_public_path__ + "static/media/userPolicyIcon.93cf81b7.svg";
export { ForwardRef as ReactComponent };